/* The Yardage Book — interactions: ball-flight scroll line, reveals, lite video, menu */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.remove('no-js');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll progress → --p, and the ball on the flight path ---- */
  var flight = document.querySelector('.flight');
  var path = flight && flight.querySelector('.flight__line');
  var ball = flight && flight.querySelector('.flight__ball');
  var total = path ? path.getTotalLength() : 0;
  var ticking = false;

  function update() {
    ticking = false;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    root.style.setProperty('--p', p.toFixed(4));
    if (path && ball && flight.offsetParent !== null) {
      var pt = path.getPointAtLength(total * p);
      var w = flight.clientWidth, h = flight.clientHeight;
      ball.style.setProperty('--bx', (pt.x / 40) * w + 'px');
      ball.style.setProperty('--by', (pt.y / 1000) * h + 'px');
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();

  /* ---- Reveal on scroll ---- */
  var revealables = document.querySelectorAll('[data-reveal], .holemap[data-draw]');
  if (reduced || !('IntersectionObserver' in window)) {
    revealables.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    revealables.forEach(function (el) { io.observe(el); });
  }

  /* ---- Lite video: load the iframe only on click ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-video-id]');
    if (!btn) return;
    var id = btn.getAttribute('data-video-id');
    var type = btn.getAttribute('data-video-type');
    var title = btn.getAttribute('aria-label') || 'Video';
    var src = type === 'vimeo'
      ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
      : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = title;
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    btn.parentNode.replaceChild(iframe, btn);
  });

  /* ---- Vimeo thumbnails (public videos) ---- */
  document.querySelectorAll('[data-video-type="vimeo"]').forEach(function (btn) {
    if (btn.querySelector('img')) return;
    var id = btn.getAttribute('data-video-id');
    fetch('https://vimeo.com/api/oembed.json?width=1280&url=' + encodeURIComponent('https://vimeo.com/' + id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.thumbnail_url) return;
        var img = document.createElement('img');
        img.src = d.thumbnail_url; img.alt = ''; img.loading = 'lazy';
        btn.insertBefore(img, btn.firstChild);
      }).catch(function () {});
  });

  /* ---- The client course: flags along a par 5, tee (first) to green (now) ---- */
  document.querySelectorAll('[data-cc]').forEach(function (cc, ci) {
    var line = cc.querySelector('.cc__line'), pinsBox = cc.querySelector('[data-cc-pins]'), ball = cc.querySelector('[data-cc-ball]');
    var items = Array.prototype.slice.call(cc.querySelectorAll('[data-cc-list] li'));
    if (!line || !items.length || !line.getTotalLength) return;
    var L = line.getTotalLength(), n = items.length, pins = [];
    var levels = ['up1', 'down1', 'up2', 'down2'];
    items.forEach(function (li, i) {
      var t = n === 1 ? 1 : 0.035 + i * (0.965 / (n - 1));
      var pt = line.getPointAtLength(t * L);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cc-pin cc-pin--' + (i === n - 1 ? 'up2' : levels[i % 4]) + ' s-' + (li.dataset.sector || 'tech');
      if (i === n - 1) b.className += ' cc-pin--now';
      b.style.left = (pt.x / 1200 * 100) + '%';
      b.style.top = (pt.y / 440 * 100) + '%';
      var tipId = 'cc-tip-' + ci + '-' + i;
      b.setAttribute('aria-describedby', tipId);
      var tag = document.createElement('span'); tag.className = 'cc-pin__tag';
      if (li.dataset.logo) { var im = document.createElement('img'); im.src = li.dataset.logo; im.alt = li.dataset.name; tag.appendChild(im); }
      else tag.textContent = li.dataset.name;
      var tip = document.createElement('span'); tip.className = 'cc-pin__tip'; tip.id = tipId; tip.setAttribute('role', 'tooltip');
      var h = document.createElement('strong'); h.textContent = li.dataset.name; tip.appendChild(h);
      if (li.dataset.where) { var w = document.createElement('span'); w.textContent = li.dataset.where; tip.appendChild(w); }
      if (li.dataset.years) { var y = document.createElement('span'); y.className = 'cc-pin__years'; y.textContent = li.dataset.years; tip.appendChild(y); }
      var hole = document.createElement('span'); hole.className = 'cc-pin__hole'; hole.textContent = 'Flag ' + (i + 1) + ' of ' + n + (i === n - 1 ? ' · on the green' : ''); tip.appendChild(hole);
      b.appendChild(tag); b.appendChild(tip);
      pinsBox.appendChild(b);
      pins.push({ el: b, t: t });
    });
    cc.classList.add('cc--live');
    var play = function () {
      if (reduced) { pins.forEach(function (p) { p.el.classList.add('is-lit'); }); ball.style.display = 'none'; return; }
      var t0 = performance.now(), dur = 3600;
      var step = function (now) {
        var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 2.2);
        var pt = line.getPointAtLength(e * L);
        ball.style.left = (pt.x / 1200 * 100) + '%'; ball.style.top = (pt.y / 440 * 100) + '%';
        pins.forEach(function (p) { if (e >= p.t - 0.005) p.el.classList.add('is-lit'); });
        if (k < 1) requestAnimationFrame(step); else ball.classList.add('is-holed');
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); play(); } }, { threshold: 0.35 });
      io.observe(cc);
    } else play();
  });

  /* ---- Mobile menu: close on link click or Escape ---- */
  var menu = document.querySelector('.menu-toggle');
  if (menu) {
    menu.addEventListener('toggle', function () {
      document.body.style.overflow = menu.open ? 'hidden' : '';
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('.menu-panel a')) menu.open = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
  }
})();
